import { IColors } from "../types";

export const darkThemeColors: IColors = {
    "primary-base": "#000",
    "primary-25": "#050506",
    "primary-50": "#0d0d0e",
    "primary-100": "#171819",
    "primary-200": "#27282a",
    "primary-300": "#38393b",
    "primary-400": "#4a4c4e",
    "primary-500": "#5c5e61",
    "primary-600": "#6e7175",
    "primary-700": "#828588",
    "primary-800": "#969a9e",
    "primary-900": "#b3b7bb",
    "primary-1000": "#c8cbce",
    "primary-1100": "#d7dadc",
    "primary-1200": "#ecedef",
    "secondary-25": "#0d0300",
    "secondary-50": "#1a0901",
    "secondary-100": "#2a1202",
    "secondary-200": "#411f06",
    "secondary-300": "#5a2d0c",
    "secondary-400": "#743d12",
    "secondary-500": "#8a4f16",
    "secondary-600": "#a16318",
    "secondary-700": "#b77718",
    "secondary-800": "#cd8c16",
    "secondary-900": "#ebab09",
    "success-25": "#000706",
    "success-50": "#01100E",
    "success-100": "#031C19",
    "success-200": "#072E2A",
    "success-300": "#0E403B",
    "success-400": "#14544E",
    "success-500": "#18695F",
    "success-600": "#1A7E71",
    "success-700": "#1A9584",
    "success-800": "#17AD96",
    "success-900": "#29CCB1",
    "surface-base": "#000",
    "surface-25": "#050506",
    "surface-50": "#0D0D0E",
    "surface-100": "#171819",
    "surface-200": "#27282A",
    "surface-300": "#38393B",
    "surface-400": "#4A4C4E",
    "surface-500": "#5C5E61",
    "surface-600": "#6E7175",
    "surface-700": "#828588",
    "surface-800": "#969A9E",
    "surface-900": "#B3B7BB",
    "surface-1000": "#C8CBCE",
    "surface-1100": "#D7DADC",
    "surface-1200": "#ECEDEF",
    "tertiary-25": "#000514",
    "tertiary-50": "#020c24",
    "tertiary-100": "#051737",
    "tertiary-200": "#0c2754",
    "tertiary-300": "#143773",
    "tertiary-400": "#1b4993",
    "tertiary-500": "#1f5cb0",
    "tertiary-600": "#2270cf",
    "tertiary-700": "#2385ee",
    "tertiary-800": "#399dfb",
    "tertiary-900": "#6cbdfe",
    "error-25": "#110201",
    "error-50": "#200502",
    "error-100": "#320b05",
    "error-200": "#4d150c",
    "error-300": "#692015",
    "error-400": "#892b1e",
    "error-500": "#aa3426",
    "error-600": "#ce3c2f",
    "error-700": "#f0473c",
    "error-800": "#f86e64",
    "error-900": "#fc9d96",
    "text-primary-100": "#171819",
    "text-primary-200": "#27282a",
    "text-primary-300": "#38393b",
    "text-primary-400": "#4a4c4e",
    "text-primary-500": "#5c5e61",
    "text-primary-600": "#6e7175",
    "text-primary-700": "#828588",
    "text-primary-800": "#969a9e",
    "text-primary-900": "#b3b7bb",
    "text-primary-1000": "#c8cbce",
    "text-primary-1100": "#d7dadc",
    "text-primary-1200": "#ecedef",
    "text-primary-base": "#000",
    "text-secondary-100": "#2a1202",
    "text-secondary-200": "#411f06",
    "text-secondary-300": "#5a2d0c",
    "text-secondary-400": "#743d12",
    "text-secondary-500": "#8a4f16",
    "text-secondary-600": "#a16318",
    "text-secondary-700": "#b77718",
    "text-secondary-800": "#cd8c16",
    "text-secondary-900": "#ebab09",
    "text-tertiary-100": "#051737",
    "text-tertiary-200": "#0c2754",
    "text-tertiary-300": "#143773",
    "text-tertiary-400": "#1b4993",
    "text-tertiary-500": "#1f5cb0",
    "text-tertiary-600": "#2270cf",
    "text-tertiary-700": "#2385ee",
    "text-tertiary-800": "#399dfb",
    "text-tertiary-900": "#6cbdfe",
    "text-success-100": "#0b1c03",
    "text-success-200": "#152e07",
    "text-success-300": "#20410d",
    "text-success-400": "#2c5514",
    "text-success-500": "#376919",
    "text-success-600": "#437f1c",
    "text-success-700": "#4e951e",
    "text-success-800": "#59ac1e",
    "text-success-900": "#6dcc24",
    "text-error-100": "#320b05",
    "text-error-200": "#4d150c",
    "text-error-300": "#692015",
    "text-error-400": "#892b1e",
    "text-error-500": "#aa3426",
    "text-error-600": "#ce3c2f",
    "text-error-700": "#f0473c",
    "text-error-800": "#f86e64",
    "text-error-900": "#fc9d96",
    "background-primary-25": "#050506",
    "background-primary-50": "#0d0d0e",
    "background-primary-100": "#171819",
    "background-primary-200": "#27282a",
    "background-primary-300": "#38393b",
    "background-primary-800": "#969a9e",
    "background-primary-900": "#b3b7bb",
    "background-primary-1200": "#ecedef",
    "background-primary-base": "#000",
    "background-secondary-25": "#0d0300",
    "background-secondary-50": "#1a0901",
    "background-secondary-100": "#2a1202",
    "background-secondary-200": "#411f06",
    "background-secondary-300": "#5a2d0c",
    "background-secondary-600": "#a16318",
    "background-secondary-700": "#b77718",
    "background-secondary-800": "#cd8c16",
    "background-tertiary-25": "#000514",
    "background-tertiary-50": "#020c24",
    "background-tertiary-100": "#051737",
    "background-tertiary-200": "#0c2754",
    "background-tertiary-300": "#143773",
    "background-tertiary-600": "#2270cf",
    "background-tertiary-700": "#2385ee",
    "background-tertiary-800": "#399dfb",
    "background-success-25": "#020700",
    "background-success-50": "#051001",
    "background-success-100": "#0b1c03",
    "background-success-200": "#152e07",
    "background-success-300": "#20410d",
    "background-success-600": "#437f1c",
    "background-success-700": "#4e951e",
    "background-success-800": "#59ac1e",
    "background-error-25": "#110201",
    "background-error-50": "#200502",
    "background-error-100": "#320b05",
    "background-error-200": "#4d150c",
    "background-error-300": "#692015",
    "background-error-600": "#ce3c2f",
    "background-error-700": "#f0473c",
    "background-error-800": "#f86e64",
    "border-primary-100": "#171819",
    "border-primary-200": "#27282a",
    "border-primary-300": "#38393b",
    "border-primary-400": "#4a4c4e",
    "border-primary-500": "#5c5e61",
    "border-primary-900": "#b3b7bb",
    "border-primary-1200": "#ecedef",
    "border-secondary-100": "#2a1202",
    "border-secondary-200": "#411f06",
    "border-secondary-300": "#5a2d0c",
    "border-secondary-400": "#743d12",
    "border-secondary-500": "#8a4f16",
    "border-secondary-700": "#b77718",
    "border-secondary-800": "#cd8c16",
    "border-tertiary-100": "#051737",
    "border-tertiary-200": "#0c2754",
    "border-tertiary-300": "#143773",
    "border-tertiary-400": "#1b4993",
    "border-tertiary-500": "#1f5cb0",
    "border-tertiary-700": "#2385ee",
    "border-tertiary-800": "#399dfb",
    "border-success-100": "#0b1c03",
    "border-success-200": "#152e07",
    "border-success-300": "#20410d",
    "border-success-400": "#2c5514",
    "border-success-500": "#376919",
    "border-success-700": "#4e951e",
    "border-success-800": "#59ac1e",
    "border-error-100": "#320b05",
    "border-error-200": "#4d150c",
    "border-error-300": "#692015",
    "border-error-400": "#892b1e",
    "border-error-500": "#aa3426",
    "border-error-700": "#f0473c",
    "border-error-800": "#f86e64",
    "warning-25": "#110200",
    "warning-50": "#1F0502",
    "warning-100": "#310C04",
    "warning-200": "#4B170B",
    "warning-300": "#682212",
    "warning-400": "#853019",
    "warning-500": "#A13E1D",
    "warning-600": "#BF4D20",
    "warning-700": "#DD5D21",
    "warning-800": "#F07833",
    "warning-900": "#F5A468",
    "pink-25": "#130007",
    "pink-50": "#220111",
    "pink-100": "#35041D",
    "pink-200": "#51092F",
    "pink-300": "#6E1042",
    "pink-400": "#8E1959",
    "pink-500": "#AB2374",
    "pink-600": "#C92F92",
    "pink-700": "#E73BB2",
    "pink-800": "#F363C3",
    "pink-900": "#F897D8",
    "purple-25": "#06011E",
    "purple-50": "#0F0432",
    "purple-100": "#1B084B",
    "purple-200": "#2C1270",
    "purple-300": "#3E1C98",
    "purple-400": "#5222C8",
    "purple-500": "#6432ED",
    "purple-600": "#7552F6",
    "purple-700": "#886FF9",
    "purple-800": "#9B8AFB",
    "purple-900": "#B7ADFD",
    "green-25": "#020700",
    "green-50": "#051001",
    "green-100": "#0B1C03",
    "green-200": "#152E07",
    "green-300": "#20410D",
    "green-400": "#2C5514",
    "green-500": "#376919",
    "green-600": "#437F1C",
    "green-700": "#4E951E",
    "green-800": "#59AC1E",
    "green-900": "#6DCC24"
};
